import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'antd';
import Modal from '../../../../../components/Modal/Modal';
import Export from '../../../../../components/Export/Export';
import Import from '../../../../../components/Import/Import';
import StrategicThirdPartyEdit from './StrategicThirdPartyEdit';
import * as actions from '../StrategicThirdPartyAction';
import { orgIdSelector, businessNameSelector } from '../../../OrganisationSelectors';
import { loadingStrategicThirdPartySelector } from '../StrategicThirdPartySelectors';

const StrategicThirdPartyActionBar = ({
  orgId,
  businessName,
  strategicThirdPartyClass,
  strategicThirdPartyCategories,
  downloadStrategicThirdPartyImportTemplate,
  exportStrategicThirdParty,
  importStrategicThirdParty
}) => {
  const strategicThirdPartyClassId =
    strategicThirdPartyCategories && strategicThirdPartyCategories.length > 0
      ? strategicThirdPartyCategories[0].strategicThirdPartyClassId
      : 0;

  return (
    <>
      <Export
        fileName={`${businessName.replace(/\s+/g, '_')}_${strategicThirdPartyClass.replace(/\s+/g, '_')}.xlsx`}
        exportFile={() => exportStrategicThirdParty(orgId, strategicThirdPartyClassId)}
      >
        {onExport => (
          <Button
            type="default"
            className="organisation-main-section__toolbar-ghost"
            icon="export"
            htmlType="button"
            onClick={onExport}
          >
            Export
          </Button>
        )}
      </Export>
      <Modal
        title={`Import ${strategicThirdPartyClass}`}
        toggle={show => (
          <Button
            type="default"
            className="organisation-main-section__toolbar-ghost"
            icon="contacts"
            htmlType="button"
            onClick={show}
          >
            Import
          </Button>
        )}
      >
        {() => (
          <Import
            templateName={`${strategicThirdPartyClass.replace(/\s+/g, '_')}_template.xlsx`}
            downloadTemplate={() => downloadStrategicThirdPartyImportTemplate(strategicThirdPartyClassId)}
            importFromTemplate={file => importStrategicThirdParty(orgId, file, strategicThirdPartyClassId)}
          />
        )}
      </Modal>
      <Modal
        explanation
        toggle={show => (
          <Button
            type="primary"
            className="organisation-main-section__toolbar-primary"
            htmlType="button"
            onClick={show}
          >
            Add new
          </Button>
        )}
      >
        {(hide, setExplanation) => (
          <StrategicThirdPartyEdit
            strategicThirdPartyCategories={strategicThirdPartyCategories}
            close={hide}
            onExplanationChange={setExplanation}
          />
        )}
      </Modal>
    </>
  );
};

StrategicThirdPartyActionBar.propTypes = {
  orgId: PropTypes.number.isRequired,
  businessName: PropTypes.string.isRequired,
  strategicThirdPartyClass: PropTypes.string.isRequired,
  strategicThirdPartyCategories: PropTypes.arrayOf(PropTypes.object).isRequired,
  downloadStrategicThirdPartyImportTemplate: PropTypes.func.isRequired,
  exportStrategicThirdParty: PropTypes.func.isRequired,
  importStrategicThirdParty: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  orgId: orgIdSelector(state),
  businessName: businessNameSelector(state),
  loading: loadingStrategicThirdPartySelector(state)
});

const mapDispatchToProps = { ...actions };

export default connect(mapStateToProps, mapDispatchToProps)(StrategicThirdPartyActionBar);
